import type { TOC } from '@ember/component/template-only';
import safeFormatNumber from 'tio-common/helpers/safe-format-number';
import { divide } from 'tio-ui/math';
import { t } from 'ember-intl';

interface AccountingPaymentsSummarySignature {
  Args: {
    model: {
      total?: number | null;
    };
  };
}

const AccountingPaymentsSummary: TOC<AccountingPaymentsSummarySignature> = <template>
  {{#if @model.total}}
    <p class="mx-2 mb-3">
      <span class="font-semibold">
        {{safeFormatNumber (divide @model.total 100) style="currency" currency="USD"}}
      </span>
      {{t "contributions.total_to_date"}}
    </p>
  {{/if}}
</template>;

export default AccountingPaymentsSummary;
